// extracted by mini-css-extract-plugin
export default {"skeleton":"RYzPg","loading":"HEwPA","container":"YV2UQ","link":"Usg4d","image":"koNJl","closeButton":"G9vDy","closeIcon":"ZRsZ4"};